import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'single-statistic-box',
    templateUrl: './single-statistic-box.component.html',
    styleUrl: './single-statistic-box.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SingleStatisticBoxComponent {
    public label = input.required<string>();

    public value = input.required<number | string | null | undefined>();

    public unit = input.required<string>();

    public info = input.required<string>();

    public type = input<string>();

    public format = input<string>();
}
